/**
 * SIO PostHog API survey question ids (public config — not env).
 * Survey: "SIO Product Feedback" in project 499980.
 * @see docs/project-management/2-in-progress (2-max)/in-app-feedback-host/artifacts/phase-0-decisions.md
 */
export const PRODUCT_FEEDBACK_QUESTION_IDS = {
  category: "915f7f5e-7d4d-4b9d-92a5-c3b6ea00f706",
  primary: "16137eea-a144-4d2a-b919-82d79dbb9bd4",
  secondary: "a62d2533-2810-4f97-9425-e59685f8f39c",
  anythingElse: "e9db7cdc-f88d-4bf5-a37c-1fd5f8b9bf35",
} as const;
